export default __webpack_public_path__ + "static/media/1278.aaef35d0.png";